<template>
    <div class="g-popup preview" v-if="showTagDialog" style="z-index: 100">
        <!-- 标签选择弹窗 [[ -->
        <div class="popup-con label-select-popup">
            <div class="popup-close js-close-channel">
                <i class="ico ico-close" @click="closeTagDialog"></i>
            </div>
            <h5 class="popup-title">标签选择</h5>
            <div class="lsp-con">
                <div class="already-chosen" style="min-height: 3rem">
                    <h5 class="lsp-con-tit">已选择标签</h5>
                    <p class="edit-lable-con" v-for="sTag in selectedTags" :key="sTag">
                        <span class="edit-lable-text f-hide-col-1">{{ sTag.tagName }}</span>
                        <span class="ico ico-label-close" @click="removeSelectItem(sTag)"></span>
                    </p>
                </div>
                <div class="all-label">
                    <h5 class="lsp-con-tit">所有标签</h5>
                    <el-tree
                        class="el-tree-r"
                        :data="tagData"
                        :filter-node-method="filterNode"
                        :props="defaultProps"
                        @node-click="handleNodeClick"
                        show-checkbox
                        node-key="id"
                        ref="tagTree"
                        check-strictly="true"
                        highlight-current
                        @check-change="handleNodeChange"
                    ></el-tree>
                </div>
            </div>
            <div class="g-bottom-btn">
                <a class="button popup-btn-confirm" href="javascript:;" @click="submitTag">确认</a>
                <a class="button popup-btn-cancel" href="javascript:;" @click="closeTagDialog">取消</a>
            </div>
        </div>
        <!-- 标签选择弹窗 ]] -->
    </div>
</template>
<style  lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/contribution.scss";
@import "~Assets/sass/pages/v4/order/order_contribute.scss";
.el-tree-r {
    width: 90%;
    height: 350px;
    overflow-y: scroll;
}
.el-tree-r::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
.el-tree-r::-webkit-scrollbar-button {
    width: 0;
    height: 0;
}
.el-tree-r::-webkit-scrollbar-corner {
    display: block;
}
.el-tree-r::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: #fd7e28;
    border-radius: 4px;
}
</style>
<script>
import {
    GameTags, GameKeywords 
} from "Services/getData.js";
export default {
    name: "tag_dialog.vue",
    props: ["curGameId", "selectedTags"],
    data() {
        return {
            showTagDialog: false,
            tagData: [],
            defaultProps: {
                children: "children",
                label: "tagName"
            },
            selectedTags: [],
            visible: true
        };
    },
    created() {
        if (this.curGameId > 0) {
            this.getTags();
        }
    },
    mounted() {},
    updated() {
        if (this.$refs.tagTree) {
            this.setTreeSelectedNode();
        }
    },
    watch: {
        visible() {
            this.$emit("update:visible", this.visible);
            // this.searchReset()
        },
        gameId() {
            this.treeNodeList = [];
            this.getTags();
        },
        selectedTags() {
            this.$emit("update:selectedTags", this.selectedTags);
            let tagId = this.selectedTags.map(tag => {
                return tag.id;
            });
            this.$emit("update:tags", tagId.join(","));
        },
        filterText(val) {
            this.$refs.tagTree.filter(val);
        }
    },
    methods: {
        setTreeSelectedNode() {
            let checkedNodesId = [];
            for (let i = 0; i < this.selectedTags.length; i++) {
                checkedNodesId.push(this.selectedTags[i].id);
            }
            if (this.$refs.tagTree) {
                this.$refs.tagTree.setCheckedKeys(checkedNodesId);
            }
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        handleNodeClick(data) {
            console.log(data);
        },
        handleNodeChange(data, ischecked, isChildrenChecked) {
            // data:当前节点、 isChecked标识当前节点是否被选中、 isChildrenChecked标识是否存在被选中的子节点
            // if(this.selectedTags.length >= 5){
            //    this.$alert('最多选择5个标签哦~');
            //    this.$refs.tagTree.setCheckedKeys([]);
            //    this.selectedTags = [];
            //    return false;
            // }
            if (ischecked) {
                // 增加选中节点
                let ablePush = true;
                this.selectedTags.filter(tag => {
                    if (tag.id == data.id) {
                        ablePush = false;
                    }
                });
                if (ablePush) {
                    this.selectedTags.push(data);
                }
            } else {
                for (let key in this.selectedTags) {
                    // 删除操作
                    if (this.selectedTags[key].id == data.id) {
                        this.selectedTags.splice(key, 1);
                    }
                }
            }
            this.$emit("update:selectedTags", this.selectedTags);
        },
        removeSelectItem(item) {
            item.isSelected = false;
            let matchIndex = -1;
            for (let i = 0; i < this.selectedTags.length; i++) {
                if (this.selectedTags[i].id == item.id) {
                    matchIndex = i;
                    break;
                }
            }
            if (matchIndex !== -1) {
                this.selectedTags.splice(matchIndex, 1);
            }
            // 重置节点的选中状态
            if (this.$refs.tagTree) {
                this.$refs.tagTree.setChecked(item.id, false, false);
            }
        },
        submitTag() {
            if (this.selectedTags.length > 9) {
                this.$alert("最多选择9个标签哦~");
                return false;
            }
            this.showTagDialog = false;
        },
        closeTagDialog() {
            this.showTagDialog = false;
            this.$emit("cancelSubmit");
        },
        showDialog() {
            this.showTagDialog = true;
            this.getTags();
        },
        async getTags() {
            let res = await GameTags({
                gameId: this.curGameId,
                isTree: 1
            });
            if (res.status == 200 && res.data.data.length) {
                let data = res.data.data;
                this.tagData = data;
                this.$nextTick(() => {
                    this.setTreeSelectedNode();
                });
            }
        }
    }
};
</script>

<style scoped>
</style>
